// extracted by mini-css-extract-plugin
export default {"requiredIndicator":"required-indicator_requiredIndicator__zvizG"};